import PolicyTemplate from '../components/o_series/common/PoliciesTemplate'
import s from '../components/o_series/common/Policies.module.css'

const TermsOfService: React.FC = () => {
  return (
    <PolicyTemplate>
      <div className={`px-2 md:px-0 container mx-auto pb-10 ${s.policy}`}>
        <h3 className="mb-4 font-bold text-lg">Terms of service</h3>
        <ol>
          <li className="mb-2">
            <strong>Terms of service</strong>
          </li>
          <ol>
            <li>
              These terms of use apply to the service providers KETO SIA,
              registration number: 50203370651, VAT number: LV50203370651, legal
              address: Lastadijas Street 6, LV-1050, Riga, Latvia and its
              authorized companies (“Service Provider”) the website, portal and
              application KetoGo.app (hereinafter together referred to as the
              “Site”) offered services (hereinafter referred to as the
              “Service”).
            </li>
            <li>
              The Terms of Use of the Service (hereinafter referred to as the
              “Terms”) are binding on all persons using the Service and the
              Site, regardless of whether the respective person is a user
              registered on the Site or not (hereinafter referred to as the
              “User”).
            </li>
            <li>
              Simultaneously with the use of the Service, including visiting the
              Site, other terms and conditions on the Site also come into force.
              If the User uses the Service and uses the Site or performs any
              actions in it, then it is considered that the respective User has
              read the Terms in force at the time of use and agrees to comply
              with them.
            </li>
            <li>
              A user who does not agree with any of the conditions of the Terms
              is not entitled to use the Site and the Service.
            </li>
            <li>
              The Terms and Conditions apply to all matters to which the
              applicable legislation of the Republic of Latvia on the use of
              services cannot be applied, and they form a complete agreement
              between the Service Provider and the User. If any provision of
              these Terms is held to be invalid or unenforceable by a court, the
              remaining provisions of these Terms shall remain in full force and
              effect.
            </li>
            <li>
              The Service Provider reserves the right to unilaterally, at any
              time amend and / or change the Terms. The Regulations enter into
              force after their publication on the Portal. The user is obliged
              to follow and get acquainted with the Terms, as well as to comply
              with them.
            </li>
            <li>
              These Terms shall be deemed to be a service agreement concluded
              between the Service Provider and the User, which is concluded for
              an indefinite period of time. The User has the right to
              unilaterally terminate the use of the Service by terminating its
              payment. The Service Provider has the right to unilaterally
              terminate the provision of this Service to the User without prior
              notice to the User and indicating the reason for termination of
              obligations, in accordance with the violation in accordance with
              these Terms.
            </li>
          </ol>
          <li>
            <strong>Service</strong>
          </li>
          <ol>
            <li>
              The Service is a participation in a program that includes
              information related to a healthy lifestyle and diet. If the User
              is concerned about the information received on the Site or has
              questions about his / her health, the User must consult the
              nutritionist available on the Site.
            </li>
            <li>
              The Service may include, but is not limited to, applications,
              email services, messages and message boards, chat areas,
              newsgroups, and downloadable mobile applications related to the
              services available on the Site.
            </li>
            <li>
              The Site may contain links to third party websites or services for
              the content of which the Service Provider is not responsible. The
              Service Provider shall not be liable for any damages caused to the
              User on third party websites.
            </li>
            <li>
              The service is not recommended for pregnant women. The service may
              be used by persons over 18 years of age.
            </li>
          </ol>
          <li>
            <strong>Technical processes of Service purchases</strong>
          </li>
          <ol>
            <li>
              In order to receive Service offered on the Site, the User must
              register according to the registration procedure available on the
              Site.
            </li>
            <li>
              In the registration form, the User must list true, correct,
              complete and current information.
            </li>
            <li>
              In order to register with the Site and receive Service, the User
              must carry out these or other (in accordance with instructions of
              the Site) actions:
            </li>
            <ol>
              <li>
                The User must complete the tests available through the Site;
              </li>
              <li>
                after completing the test, the User must indicate their personal
                e-mail address, to which the Service Provider will send
                information about the Service;
              </li>
              <li>
                the User must choose the most appropriate payment method with
                which to pay for Service;
              </li>
              <li>
                the User must take all necessary steps in order to pay for the
                Service;
              </li>
              <li>the User must complete the registration form.</li>
            </ol>
            <li>
              After successful registration, payment and completion of the test,
              the User will receive a notification in the specified e-mail about
              successful registration for participation in the program and
              access to the Service.
            </li>
          </ol>
          <li>
            <strong>Quality of Service</strong>
          </li>
          <ol>
            <li>
              The Service is provided on an “AS IS” and “AS AVAILABLE” basis,
              which means that Service Provider does not guarantee that:
            </li>
            <ol>
              <li>
                the results of using the Service will meet Users requirements;
              </li>
              <li>
                Service is free of viruses, technical errors, technical
                disruptions, security holes;
              </li>
              <li>Service is available anytime and anywhere.</li>
            </ol>
            <li>
              Service Provider, on its sole discretion, reserves the right to
              refuse, cancel or to terminate the Services received by the User
              if there is a suspicion that the User has specified false data in
              the registration form or if there is a suspicion that the User has
              purchased Service fraudulently.
            </li>
            <li>
              Information about the Service available on the Site are constantly
              updated, changed or improved. Thus, information about the Service
              on the Site, such as, but not limited to prices of the Service,
              descriptions and other information may be listed incorrectly or
              incompletely.
            </li>
            <li>
              Images have an illustrative meaning, the actual appearance of the
              product or service may differ from those shown in the ads.
            </li>
          </ol>
          <li>
            <strong>Payment for Service</strong>
          </li>
          <ol>
            <li>
              In order to receive the Service available on Site, the User agrees
              to provide the information necessary to make a payment for the
              Service, including, but not limited to, credit card number, credit
              card expiration date, billing address, cardholder’s name and
              surname.
            </li>
            <li>
              In paying for the Service, the User confirms and guarantees that:
            </li>
            <ol>
              <li>
                they have the legal right to use any credit card(s) or other
                payment method(s) in connection with any Purchase;
              </li>
              <li>supplied information is true, correct and complete.</li>
            </ol>
            <li>
              By submitting information set out in paragraph 5 of these Terms,
              the User grants Service Provider the right to provide the
              information to third parties for purposes of facilitating the
              completion of Purchases.
            </li>
            <li>
              If the User chooses to pay for the Service with PayPal or a
              payment card, after making a one-time payment, the User will be
              able to apply for the Subscription Service. When the user selects
              and purchases the Subscription Service, payments will be made
              automatically, once a month.
            </li>
            <li>
              If users choose to pay for the Service with Internet banking, the
              Service will be suspended after the first month with the
              possibility to renew participation in the program.
            </li>
          </ol>
          <li>
            <strong>User’s Account</strong>
          </li>
          <ol>
            <li>
              In order to use the Service, the User must become a registered
              user by filling in the registration form on the Site. The user is
              responsible for maintaining this account and not passing access to
              this account to others.
            </li>
            <li>
              he user is aware of the processing of personal data in their
              profile, which is explained in more detail in the{' '}
              <a className="link" href="/privacy-policy">
                Privacy policy
              </a>
              . After creating an account on the Site, the User is responsible
              for using this account.
            </li>
            <li>
              Each User account on the Site is created individually for each
              User and is meant for individual use only; the User is not
              authorized to transfer the account to another person or third
              party.
            </li>
            <li>
              The Service Provider is entitled to suspend the User’s account,
              without a refund if:
            </li>
            <ol>
              <li>
                during registration the User has indicated false or incorrect
                data;
              </li>
              <li>
                the User has transferred use of their personal account to
                another person;
              </li>
              <li>
                there is suspicion of fraudulent, unauthorized or unlawful
                activity;
              </li>
              <li>the User has otherwise violated Site terms.</li>
            </ol>
            <li>
              The Service Provider does not take any responsibility for the
              suspension or termination of the User`s account.
            </li>
            <li>
              The User has the right to close or delete their personal account
              by following appropriate instructions on the Site or by sending a
              request to the Service Provider’s e-mail, hello@ketogo.app,
              regarding the desire to close their account
            </li>
            <li>
              After the termination of the User’s account, the Service Provider
              may discard all the User’s information related to the Service,
              including, but not limited to: weight loss analysis, all provided
              consultations, weight loss plans and food menus
            </li>
          </ol>
          <li>
            <strong>About the Service’s purchase refund</strong>
          </li>
          <ol>
            <li>
              The User has the right to receive a full refund within 14 days of
              any purchase made on the Site, if not stated otherwise on the Site
              or in the Service description. In order to receive a refund, the
              User must contact the Service Provider by writing to the e-mail:
              hello@ketogo.app, including documents confirming the purchase and
              requesting to return the paid money (example of the form for the
              use of refusal rights).
            </li>
            <li>
              If the Site registered User for some reason is not satisfied with
              the results achieved, the Service Provider guarantees the refund
              of money paid on the same working day after receipt of the
              request.
            </li>
            <li>
              If the Service Provider recognizes the User`s complaint as
              unfounded and the User does not agree with the recognition of the
              complaint as unfounded, the User has the right to use the
              alternative dispute resolution options specified in regulatory
              enactments by submitting a written application to the Service
              Provider for out-of-court dispute resolution.
            </li>
            <ol>
              <li>Name, surname, contact information;</li>
              <li>the submission date of the application;</li>
              <li>
                the nature of the dispute, the claims and the grounds on which
                they are based.
              </li>
            </ol>
            <li>
              Information about the dispute resolution process:
              www.ptac.gov.lv/lv/content/stridu-risinasanas-process
            </li>
            <li>
              Information on the out-of-court consumer dispute resolution
              database:
              www.ptac.gov.lv/lv/content/arpustiesas-pateretaju-stridu-risinataju-datubaze
            </li>
            <li>
              Online Dispute Resolution (ODR) Information: If there is a problem
              with a product purchased online, the customer can use the ODR
              platform to submit a complaint to an independent dispute
              resolution body. Link to the SIT platform:
              ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=EN
            </li>
            <li>
              The User may at any time freely and free of charge cancel the
              Service in his / her profile (in the sections “Profile”).
            </li>
          </ol>
          <li>
            <strong>Contests, Sweepstakes and Promotions</strong>
          </li>
          <ol>
            <li>
              If the User has given consent during the registration of the
              Service, the Service Provider may process the User`s e-mail
              address to inform the User about various news related to the Site
              and the Service, including advertising campaigns and other similar
              services. Further information on the processing of User personal
              data for this purpose is available in the{' '}
              <a className="link" href="/privacy-policy">
                Privacy policy
              </a>
              .
            </li>
            <li>
              Any contests, sweepstakes or other promotions (collectively,
              “Promotions”) made available through the Site may be governed by
              rules that are separate from these Terms. Before participating in
              any Promotions, please review the applicable rules. If the rules
              for a Promotion conflict with these Terms, the Promotion rules
              will apply.
            </li>
            <li>
              The User may at any time withdraw from receiving Promotions by
              following the appropriate instructions, or by writing to the
              Service Provider’s e-mail: hello@ketogo.app.
            </li>
          </ol>
          <li>
            <strong>Intellectual Property</strong>
          </li>
          <ol>
            <li>
              The Service Provider owns exclusive rights over all information
              available on the Site, therefore any third party content, design
              processing, further distribution of data and / or other use of the
              information and further distribution without permission of the
              Service Provider or written consent is copyright and other right
              infringement, which is punishable under the laws of the Republic
              of Latvia.
            </li>
            <li>
              In cases of infringement of intellectual property rights, the
              Service Provider is entitled to prosecute the guilty person, who
              is fully responsible for all damages that are or could be caused
              to the Service Provider and third parties (including lost
              profits).
            </li>
          </ol>
          <li>
            <strong>Service Provider’s liability</strong>
          </li>
          <ol>
            <li>
              The Service Provider does not hold any kind of responsibility for
              losses accrued to the User, if the User has not complied with the
              Terms of the Site and / or the User has not complied with Service
              Provider’s nutrition specialist advice.
            </li>
            <li>
              The Service Provider does not hold any kind of liability for
              damage caused to the User or third parties, from following menus
              indicated by the Service or other materials provided on the Site.
            </li>
            <li>
              The Service Provider shall not bear any liability for the actions
              of the User and damages caused to third parties.
            </li>
          </ol>
          <li>
            <strong>Data protection</strong>
          </li>
          <ol>
            <li>
              All the User`s personal data submitted to the Service Provider are
              processed in accordance with Service Provider`s{' '}
              <a className="link" href="/privacy-policy">
                Privacy policy
              </a>
              .
            </li>
          </ol>
          <li>
            <strong>Settlement of disputes</strong>
          </li>
          <ol>
            <li>
              All disputes between the Service Provider and the User are settled
              through negotiations. If both parties fail to reach an agreement,
              disputes should be submitted and dealt with in the court of the
              Republic of Latvia, in accordance with the Terms and Latvian law.
            </li>
          </ol>
        </ol>
      </div>
    </PolicyTemplate>
  )
}

export default TermsOfService
